import React, { FC, ReactElement } from 'react'

import { Page } from '../../components'
import { ConnectedLeaveOfAbsences } from '../../connectors'

const LeaveOfAbsencesPage: FC = (): ReactElement => (
    <Page className="leave-of-absences-page">
        <ConnectedLeaveOfAbsences />
    </Page>
)

export default LeaveOfAbsencesPage
